import { render, staticRenderFns } from "./Suporte.vue?vue&type=template&id=47576e02&scoped=true"
import script from "./Suporte.vue?vue&type=script&lang=js"
export * from "./Suporte.vue?vue&type=script&lang=js"
import style0 from "./Suporte.vue?vue&type=style&index=0&id=47576e02&prod&lang=css"
import style1 from "./Suporte.vue?vue&type=style&index=1&id=47576e02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47576e02",
  null
  
)

export default component.exports